import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SettingsService } from 'core-lib';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { v4 as uuidv4 } from 'uuid';
import { MessageModule } from 'primeng/message';


interface IEmailOption {
    name: string;
    code: string;
}

@Component({
    selector: 'app-emailpreview',
    imports: [SelectModule, FormsModule, ButtonModule, MessageModule],
    templateUrl: './emailpreview.component.html',
    styleUrl: './emailpreview.component.scss'
})
export class EmailpreviewComponent implements OnInit, OnDestroy {
  constructor(
    private settings:SettingsService, 
    private http: HttpClient, 
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ){}

  emails:IEmailOption[] = [];
  viewOnly:boolean = false;
  selectedEmail:IEmailOption;
  content:any;
  showError:boolean = false;

  ngOnInit() {
    

    let langs = this.settings.get('app.languages');
    let hotelCodes = this.settings.get('app.endpoints')?.map((ep:any) => ep.hotelCode);


    langs.forEach((lang:string) => {
      hotelCodes.forEach((hotelCode:string) => {
        let cancellation = `${lang.toUpperCase()}_ReservationCancellation_${hotelCode}`;
        let confirmation = `${lang.toUpperCase()}_ReservationConfirmation_${hotelCode}`;
        let tablereservation = `${lang.toUpperCase()}_TableReservationConfirmation_${hotelCode}`;
        this.emails.push({code: cancellation, name: `Peruutusvahvistus ${lang}, hotellikoodille ${hotelCode}`});
        this.emails.push({code: confirmation, name: `Varausvahvistus ${lang}, hotellikoodille ${hotelCode}`});
        this.emails.push({code: tablereservation, name: `Pöytävarausvahvistus ${lang}, hotellikoodille ${hotelCode}`});
      });
    });

    // deeplink: /preview?template=FI_ReservationConfirmation&hotelId=1&viewonly=true
    const params = this.route.snapshot.queryParamMap;
    const template = params.get('template');
    if (template) {
      const hotelId = params.get('hotelId');
      const code = hotelId ? `${template}_${hotelId}` : template;
      this.viewOnly = params.get('viewonly')?.toLowerCase() === 'true';
      if (this.viewOnly) {
        document.body.style.overflow = 'hidden';
      }
      this.selectedEmail = this.emails.find(e => e.code === code) ?? { code, name: code };
      this.loadEmailByCode(code);
    }
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
  }

  loadEmail() {
    if (!this.selectedEmail) {
      return;
    }
    this.loadEmailByCode(this.selectedEmail.code);
  }

  private loadEmailByCode(code: string) {
    this.showError = false;

    let endpoint = this.settings.getEndpoint();
    this.http.get(`${endpoint}/Content/html/${code}`, {
      responseType: "text",
      headers: {
        'X-Conversation-ID': uuidv4()
      }})
      .subscribe({
        next: (res) => {
          // backend returns 200 with an empty body when the template does not exist
          if (res?.trim()) {
            this.content = this.sanitizer.bypassSecurityTrustHtml(res);
          } else {
            this.content = null;
            this.showError = true;
          }
        },
        error: (err) => {
          console.error(err);
          this.content = null;
          this.showError = true;
        }
    });
  }
}
